export const MAX_VIDEO_DURATION_SEC = 900; // 15 seconds
